import React from 'react'
import NumPad from 'react-numpad'
import { toast } from 'react-toastify'
import { Card, CardContent, Typography } from '@material-ui/core'

function CampoHumedad (props) {
  const { humedad, max, min } = props

  const handleChange = (newValue) => {
    console.log('humedad --> ', newValue, max, min)
    if (newValue < max && newValue > min) {
      props.updateHumedad(newValue)
    } else {
      toast.error(`El valor de humedad ingresado no es válido`)
    }
  }

  return (
    <Card className='box-humedad' style={{ backgroundColor: '#ffffff', color: '#495057' }}>
      <NumPad.Number
        className='numpad'
        onChange={(humedad) => {
          handleChange(humedad)
        }}
        position='center'
        decimal={false}
        negative={false}
      >
        <CardContent style={{ padding: '0 0 25px 0' }}>
          <Typography style={{ textAlign: 'center', padding: '4px 0', fontSize: '20px', fontWeight: '150', color: '#ffffff', backgroundColor: '#707070' }}>
                Humedad
          </Typography>
          <Typography variant='h3' style={{ padding: '20px 0 0 0', color: '#495057' }}>
            {humedad}
          </Typography>
        </CardContent>
      </NumPad.Number>
    </Card>
  )
}

export default CampoHumedad
